module.exports = __webpack_public_path__ + "media/images/85/weight_loss_bed-a3436f624bafd9022eece868d730d8f0.jpg";